import { ConnectedPageLayout } from 'components/layout/page-layout';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';

import Typography from '@libs/ui/components/typography';

export const WrongUserType = () => {
  const { t } = useTranslation('public');

  return (
    <ConnectedPageLayout
      documentTitle={t('forbidden.documentTitle')}
      headerProps={{ accountProps: {} }}
      drawerProps={{}}
    >
      <Box pt="60px">
        <Typography variant="h1">{t('forbidden.code')}</Typography>
        <Typography variant="h3">{t('forbidden.title')}</Typography>
      </Box>
    </ConnectedPageLayout>
  );
};
